import { render, staticRenderFns } from "./eventDialog.vue?vue&type=template&id=3e8f35ff&scoped=true"
import script from "./eventDialog.vue?vue&type=script&lang=js"
export * from "./eventDialog.vue?vue&type=script&lang=js"
import style0 from "./eventDialog.vue?vue&type=style&index=0&id=3e8f35ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f35ff",
  null
  
)

export default component.exports